import type { TFunction } from 'i18next'

const LVD_PRODUCT_COMPLIANCE_FILE_DECLARATION_OF_CONFORMITY_PROGRESS_STEP_KEYS = {
  validate_requirements:
    'v2.pages.products.detail.lvdFiles.declarationOfConformity.progress.validateRequirements',
  render_pdf:
    'v2.pages.products.detail.lvdFiles.declarationOfConformity.progress.renderPdf',
  persist_output_document:
    'v2.pages.products.detail.lvdFiles.declarationOfConformity.progress.persistOutputDocument',
} as const

type LvdProductComplianceFileDeclarationOfConformityProgressStep =
  keyof typeof LVD_PRODUCT_COMPLIANCE_FILE_DECLARATION_OF_CONFORMITY_PROGRESS_STEP_KEYS

export function lvdProductComplianceFileDeclarationOfConformityProgressMessage(
  step: string,
  translate: TFunction<'common'>
): string | null {
  const key =
    LVD_PRODUCT_COMPLIANCE_FILE_DECLARATION_OF_CONFORMITY_PROGRESS_STEP_KEYS[
      step as LvdProductComplianceFileDeclarationOfConformityProgressStep
    ]
  if (key == null) {
    return null
  }
  return translate(key)
}
